import useSectors from "@/hooks/useSectors";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { SectorHexagon } from "@/ui/SectorHexagon";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import classes from "./styles.module.scss";

export default function ({ className = "py-5 py-md-6", theme = "light" }) {
  const sectors = useSectors();

  return (
    <div className={cn(className, classes.SectorHexagons)} data-bs-theme={theme}>
      <ParallaxBackground anim="y1:x2n:z0" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y2:x2:z0" image={bg_2} className={classes.bg_2} />
      <Container fluid="xl">
        <Row>
          {sectors.filter(s => s.hide_from_sectors !== true).map((sector, idx) => (
            <Col key={idx} xs={12} sm={6} md={4} className="p-3">
              <SectorHexagon {...sector} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
